import { lazyLoadLanguageAsync } from '../../lang'
import sidebarState from '../states/app'
import { TOGGLE_SIDEBAR, CLOSE_SIDEBAR, TOGGLE_DEVICE, SET_LANGUAGE } from '../mutation-types'
import { SIDEBAR_KEY, LANGUAGE_KEY } from '../../utils/localStorageKeys'
import { APP_DEFAULT_LOCALE, APP_LANGUAGE_LIST } from '../../utils/const'

const app = {
  namespaced: true,
  state: {
    sidebar: sidebarState(),
    device: 'desktop',
    language: localStorage.getItem(LANGUAGE_KEY) || APP_DEFAULT_LOCALE,
    cachedViews: ['paylinkGenerator', 'EditorialList', 'FileList'],
  },
  getters: {
    sidebar: state => state.sidebar,
    cachedViews: state => state.cachedViews,
    isSideBarOpen: state => state.sidebar.isOpened,
    language: state => state.language,
    languageName: (state) => {
      const language = APP_LANGUAGE_LIST.find(lang => lang.locale === state.language)
      return language.name
    },
    device: state => state.device,
  },
  actions: {
    toggleSideBar({ commit }) {
      commit(TOGGLE_SIDEBAR)
    },
    closeSideBar({ commit }, { isAnimated }) {
      commit(CLOSE_SIDEBAR, isAnimated)
    },
    toggleDevice({ commit }, device) {
      commit(TOGGLE_DEVICE, device)
    },
    setLanguage({ commit }, locale) {
      return lazyLoadLanguageAsync(locale).then(() => {
        commit(SET_LANGUAGE, locale)
      }).catch((error) => {
        console.log(error)
      })
    },
  },
  mutations: {
    [TOGGLE_SIDEBAR]: (state) => {
      localStorage.setItem(SIDEBAR_KEY, !state.sidebar.isOpened)
      state.sidebar.isOpened = !state.sidebar.isOpened
      state.sidebar.isAnimated = true
    },
    [CLOSE_SIDEBAR]: (state, isAnimated) => {
      localStorage.setItem(SIDEBAR_KEY, false)
      state.sidebar.isOpened = false
      state.sidebar.isAnimated = isAnimated
    },
    [TOGGLE_DEVICE]: (state, device) => {
      state.device = device
    },
    [SET_LANGUAGE]: (state, locale) => {
      localStorage.setItem(LANGUAGE_KEY, locale)
      state.language = locale
    },
  },
}

export default app
